import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const navigation = {
  solutions: [
    { name: 'Academic Tutoring', href: '/products/academic-tutoring' },
    { name: 'Browse Tutors', href: '/tutors' },
    { name: 'Browse Offerings', href: '/offerings' },
    { name: 'Standardized Tests', href: '/products/standardized-testing' },
  ],
  tutors: [
    { name: 'Apply as Tutor', href: '/apply-as-tutor' },
    // { name: 'Middle School Tutors', href: '#' },
    // { name: 'High School Tutors', href: '#' },
    // { name: 'College Tutors', href: '#' },
    // { name: 'Houston-area Tutors', href: '#' },
    { name: 'Tutor CRM', href: '/tutor-crm' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Careers', href: '/careers' },
    { name: 'Partnerships', href: '/partnerships' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Services', href: '/tos' },
    // { name: 'Advisory Board', href: '/advisor' },
  ],
  support: [
    { name: 'Contact Us', href: '/contact' },
    { name: 'Email Us', href: '/contact' },
    { name: 'Request a Feature', href: '/contact' },
  ],
};

const socials = [
  { name: 'LinkedIn', icon: '/social-media/LinkedinLogo.svg', href: '#' },
  { name: 'Facebook', icon: '/social-media/FacebookLogo.svg', href: '#' },
  { name: 'Twitter', icon: '/social-media/XLogo.svg', href: '#' },
  { name: 'Instagram', icon: '/social-media/InstagramLogo.svg', href: '#' },
];

export const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-logo fredoka">
            <img src={'/images/icons/logo.svg'} alt="IAMAI Logo" />
            <h2>I AM Always Improving 🚀</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          {Object.keys(navigation).map((key) => (
            <FooterSection key={key} title={key} contents={navigation[key]} />
          ))}
          <div className="col-span-2 flex h-fit !w-full flex-col justify-center rounded-[24px] bg-gradient-to-r from-[#FFF] via-[#F7F7F7] to-[#F7F7F7] p-4 md:col-span-2">
            <h2 className="mb-6 text-left text-[16px] font-semibold text-gray-800">
              Subscribe to our Newsletter
              <span className="mt-1 block text-[14px] font-normal text-gray-600">
                for our latest updates
              </span>
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your Email Address"
                className="fredoka w-full flex-shrink-0 rounded-[16px] border border-[#DCDCDC] bg-[#FFF] px-4 py-3 !text-base text-black outline-none"
                required
              />

              <button
                type="submit"
                className="fredoka flex w-full flex-shrink-0 items-center justify-center gap-[8px] rounded-[16px] border border-[#66CDCC] p-[8px_24px] text-[16px] leading-normal text-[#66CDCC]"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright fredoka">&copy; All rights reserved 2024</p>
          <div className="footer-social">
            <span className="fredoka">Connect with us</span>
            <div className="contact-box">
              {socials.map((social) => (
                <a key={social.name} href={social.href}>
                  <img src={social.icon} alt={social.name} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

function FooterSection({ title, contents }) {
  return (
    <div className="footer-section">
      <h3 className="fredoka">{title}</h3>
      <ul>
        {contents.map((item) => (
          <li key={item.name}>
            <Link className="fredoka" to={item.href}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
